import VwHbsHastaliktanimislemDTO from "../HastalikTanim/VwHbsHastaliktanimislemDTO"

class HatalikVerileriResponse{
    hastalikTaniIslemler: Array<VwHbsHastaliktanimislemDTO> = [];
    tarifeTanimId: number = null;
    ayaktanTarifeTanimId: number;
    kayitTipi: string;    
}

export default HatalikVerileriResponse